module.exports = __webpack_public_path__ + "static/media/caixa.a3d4e09e.png";